import _ from 'lodash';
import { parseHint } from './hint-manager';
import { parsePriceValue } from './price-manager';

function parseOptionsPrice(
  pricedObjectsToParse,
  // basePrices,
  // maxRequiredOptions,
  baseValue
) {
  // const basePriceValue = basePrices?.find(() => true)?.value ?? 0;
  // const maxOptionPriceValue = Math.max(
  //   ...(pricedObjectsToParse?.map((o) => o.price?.value ?? 0) ?? [0])
  // );
  // const variationRate = maxOptionPriceValue / basePriceValue;

  // if (
  //   variationRate < 0.35 ||
  //   basePrices == null ||
  //   !_.isArray(basePrices) ||
  //   basePrices.length !== 1 ||
  //   (maxRequiredOptions ?? 1) > 1
  // ) {
  //   return pricedObjectsToParse?.map((o) => {
  //     o.parsedPrice = {
  //       ...o.price,
  //     };

  //     return o;
  //   });
  // }

  return pricedObjectsToParse?.map((o) => {
    o.parsedPrice = {
      ...o.price,
      // value: (basePriceValue ?? 0) + (o.price?.value ?? 0),
      value: (o.price?.value ?? 0) - (baseValue ?? 0),
    };

    return o;
  });
}

function parseOptionDescription(option, showPrice = true) {
  if (option == null) return '';

  let priceDescription = '';
  const price = option.parsedPrice ?? option.price;

  if (showPrice && !_.isEmpty(price) && price.value > 0) {
    // const includesPlus =
    //   (option.price?.value ?? 0) === (option.parsedPrice?.value ?? 0);
    const includesPlus = true;
    priceDescription = `${includesPlus ? ' +' : ': '}${parsePriceValue(price)}`;
  }

  return (
    `${option.name} ${parseHint(option.hint, true)}`.trim() + priceDescription
  );
}

export { parseOptionDescription, parseOptionsPrice };
